<template>
  <div>
    <form role="form" @submit.prevent="updateBillingAddress" method="POST">
      <div>
        <label
          for="nameBillingAddress"
          class="block text-sm font-medium leading-5 text-gray-700 required"
        >
          Name
        </label>
        <div class="mt-1 rounded-md shadow-sm">
          <input
            id="nameBillingAddress"
            type="text"
            name="name"
            v-model="formBillingAddress.name"
            required
            class="w-full"
            placeholder="First and Last name"
          />
        </div>

        <div class="error" v-if="errors.nameBillingAddress">
          {{ errors.nameBillingAddress }}
        </div>
      </div>

      <div class="mt-6">
        <label
          for="company_name"
          class="block text-sm font-medium leading-5 text-gray-700"
        >
          Company Name
        </label>
        <div class="mt-1 rounded-md shadow-sm">
          <input
            id="company_name"
            type="text"
            name="company_name"
            v-model="formBillingAddress.company_name"
            class="w-full"
            placeholder="Company Name"
          />
        </div>

        <div class="error" v-if="errors.company_name">
          {{ errors.company_name }}
        </div>
      </div>

      <div class="mt-6">
        <label
          for="address"
          class="block text-sm font-medium leading-5 text-gray-700 required"
        >
          Address
        </label>
        <div class="mt-1 rounded-md shadow-sm">
          <input
            id="address"
            type="text"
            name="address"
            v-model="formBillingAddress.address"
            required
            class="w-full"
            placeholder="Address"
          />
        </div>

        <div class="error" v-if="errors.address">
          {{ errors.address }}
        </div>
      </div>

      <div class="mt-6">
        <label
          for="city"
          class="block text-sm font-medium leading-5 text-gray-700 required"
        >
          City
        </label>
        <div class="mt-1 rounded-md shadow-sm">
          <input
            id="city"
            type="text"
            name="city"
            v-model="formBillingAddress.city"
            required
            class="w-full"
            placeholder="City"
          />
        </div>

        <div class="error" v-if="errors.city">
          {{ errors.city }}
        </div>
      </div>

      <div class="mt-6">
        <label
          for="country"
          class="block text-sm font-medium leading-5 text-gray-700 required"
        >
          Country
        </label>
        <div class="mt-1 rounded-md shadow-sm">
          <multiselect
            v-model="countrySelected"
            :options="countries"
            track-by="name"
            label="name"
            :option-height="100"
            :show-labels="false"
            :allow-empty="false"
            placeholder="Select a Country"
          >
            <template
              slot="singleLabel"
              slot-scope="props"
              v-if="props.option.name"
              ><img
                v-if="props.option.image_url"
                class="w-8 inline-block mr-1"
                :src="aws_image_path + props.option.image_url"
                alt=""
              />
              <span class="">{{ props.option.name }}</span>
            </template>
            <template slot="option" slot-scope="props"
              ><img
                class="w-8 inline-block mr-1"
                :src="aws_image_path + props.option.image_url"
                alt=""
              />
              <span class="">{{ props.option.name }}</span>
            </template>
          </multiselect>
        </div>

        <div class="error" v-if="errors.country">
          {{ errors.country }}
        </div>
      </div>

      <div class="mt-6">
        <label
          for="postal_code"
          class="block text-sm font-medium leading-5 text-gray-700 required"
        >
          Postal Code
        </label>
        <div class="mt-1 rounded-md shadow-sm">
          <input
            id="postal_code"
            type="text"
            name="postal_code"
            v-model="formBillingAddress.postal_code"
            required
            class="w-full"
            placeholder="Postal Code"
          />
        </div>

        <div class="error" v-if="errors.postal_code">
          {{ errors.postal_code }}
        </div>
      </div>

      <div class="mt-6">
        <label
          for="vat"
          class="block text-sm font-medium leading-5 text-gray-700"
        >
          VAT Number
        </label>
        <div class="mt-1 rounded-md shadow-sm flex">
          <input
            type="text"
            class="mr-2"
            style="width: 54px"
            v-model="countrySelected.country_code"
            v-if="countrySelected"
            disabled
          />
          <input
            id="vat"
            type="text"
            name="vat"
            v-model="formBillingAddress.vat"
            class="flex-1"
            placeholder="Vat"
          />
        </div>

        <div class="error" v-if="errors.vat">
          {{ errors.vat }}
        </div>
      </div>

      <button type="submit" class="btn-primary mt-6">Save Changes</button>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    errors: Object,
  },
  data() {
    return {
      formBillingAddress: {
        name: null,
        company_name: null,
        address: null,
        city: null,
        country: null,
        postal_code: null,
        vat: null,
      },
      countries: [],
      countrySelected: null,
      aws_image_path: process.env.MIX_AWS_URL_FLAG_IMAGES,
    };
  },
  methods: {
    updateBillingAddress() {
      if (this.countrySelected == null) {
        this.$set(this.errors, "country", "The country field is required");
        return;
      }
      this.formBillingAddress.country = this.countrySelected.id;
      this.$inertia.post(
        "/user/api/store-billing-address",
        this.formBillingAddress,
        {
          preserveScroll: true,
          onSuccess: (e) => {
            this.$emit("saved");
            if (e.props.flash.message != null) {
              this.$store.commit("showFlashMessage", {
                message: e.props.flash.message,
                type: e.props.flash.message_type,
              });
            }
          },
        }
      );
    },
  },
  mounted() {
    if (this.$page.props.auth.user != null) {
      this.axios
        .get("/user/api/billing-address")
        .then((response) => {
          if (response.data) {
            if (response.data.billingAddress) {
              this.formBillingAddress = response.data.billingAddress;
              this.countrySelected = response.data.country;
            }
          }
          this.formBillingAddress.name = this.$page.props.auth.user.name;
          this.$emit("toggleShowLoading");
        })
        .catch(() => {
          this.formBillingAddress.name = this.$page.props.auth.user.name;
          this.$emit("toggleShowLoading");
        });

      this.axios.get("/countries").then((response) => {
        if (response.data) {
          this.countries = response.data;
        }
      });
    }
  },
};
</script>